











import { computed, defineComponent, PropType, ref, toRefs, watch } from '@nuxtjs/composition-api'
import { useWindowScroll, useWindowSize } from '@vueuse/core'

import useOmnichatOverride from '@/composables/use-omnichat-override'

export default defineComponent({
  props: {
    value: {
      type: Boolean,
      default: true,
    },
    stickyBottom: {
      type: Boolean,
      default: false,
    },
    minHeight: {
      type: Number,
      default: null,
    },
    omnichatOverrideStrategy: {
      type: String as PropType<'hide' | 'move'>,
      default: 'hide',
    },
    omnichatOverrideMoveOffset: {
      type: Number,
      default: 0,
    },
  },
  setup (props) {
    const {
      value,
      omnichatOverrideStrategy: strategy,
      omnichatOverrideMoveOffset: offset,
    } = toRefs(props)

    const {
      show: showOmnichat,
      hide: hideOmnichat,
      move: moveOmnichat,
      reset: resetOmnichat,
    } = useOmnichatOverride(offset.value)

    const { height } = useWindowSize()
    const { y: top } = useWindowScroll()

    const el = ref<HTMLElement>()

    const isFixed = computed(() => {
      if (!props.stickyBottom) return true
      if (!el.value) return true
      const distance = el.value?.offsetTop - top.value - 50
      const { value: windowHeight } = height

      return distance >= windowHeight
    })

    watch(
      [value, isFixed],
      () => {
        if (strategy.value === 'hide') {
          value.value ? hideOmnichat() : showOmnichat()
        } else if (strategy.value === 'move') {
          showOmnichat()
          if (value.value && isFixed.value) {
            moveOmnichat()
          } else {
            resetOmnichat()
          }
        }
      },
      { immediate: true }
    )

    return {
      el,
      isFixed,
    }
  },
})
